var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFreecodecampLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 712,
    height: 484,
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "0 0 712 484",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "f2jrM5bTZu",
    d: "M136.83 9.96C139.18 12.3 141.53 15.67 141.54 19.06C141.55 24.92 134.67 32.87 121.95 45.93C68.91 97 42.23 159.54 42.41 234.97C42.61 318.42 70.67 385.44 125.21 437.38C136.68 447.63 141.39 455.69 141.41 462.59C141.41 465.97 139.08 469.49 136.74 472.88C134.54 475.23 129.85 477.59 126.47 477.59C113.85 477.62 96.19 462.7 73.13 433.67C28.23 378.64 7.93 317.87 6.79 235.05C5.74 152.19 31.72 96 82.57 37.99C100.87 17.26 116.13 6.49 126.54 6.47C129.92 6.46 133.44 7.62 136.83 9.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fePvRWSP7",
    d: "M415.42 249.9C395.49 244.81 477.27 148.19 331.92 32.51C331.92 32.51 350.99 93.1 254.83 228.31C158.62 363.47 297.61 443.99 297.61 443.99C297.61 443.99 232.38 409.23 308.21 285.47C321.78 263.02 339.54 242.69 361.59 196.93C361.59 196.93 381.11 224.48 370.92 284.21C355.68 374.47 437.01 348.64 438.27 349.9C466.68 383.35 414.74 442.14 411.58 443.99C408.43 445.79 559.91 352.87 452.29 213.03C444.92 220.4 435.34 255 415.42 249.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "a1dIEIC07z",
    d: "M575.26 9.9C572.91 12.24 570.56 15.61 570.55 19C570.54 24.86 577.42 32.81 590.14 45.87C643.18 96.93 669.86 159.48 669.68 234.91C669.48 318.36 641.42 385.38 586.88 437.32C575.41 447.57 570.7 455.63 570.68 462.53C570.68 465.91 573.01 469.43 575.35 472.82C577.55 475.17 582.24 477.52 585.62 477.53C598.24 477.56 615.9 462.64 638.96 433.61C683.86 378.58 704.16 317.81 705.3 234.99C706.35 152.13 680.37 95.94 629.52 37.93C611.22 17.2 595.96 6.43 585.55 6.41C582.17 6.4 578.65 7.56 575.26 9.9Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "#ffffff",
    fillOpacity: 1,
    opacity: 1,
    xlinkHref: "#f2jrM5bTZu"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fillOpacity: 0,
    stroke: "#000",
    strokeOpacity: 0,
    strokeWidth: 1,
    opacity: 1,
    xlinkHref: "#f2jrM5bTZu"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "#ffffff",
    fillOpacity: 1,
    opacity: 1,
    xlinkHref: "#fePvRWSP7"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fillOpacity: 0,
    stroke: "#000",
    strokeOpacity: 0,
    strokeWidth: 1,
    opacity: 1,
    xlinkHref: "#fePvRWSP7"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "#ffffff",
    fillOpacity: 1,
    opacity: 1,
    xlinkHref: "#a1dIEIC07z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fillOpacity: 0,
    stroke: "#000",
    strokeOpacity: 0,
    strokeWidth: 1,
    opacity: 1,
    xlinkHref: "#a1dIEIC07z"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFreecodecampLogo);
export default __webpack_public_path__ + "static/media/freecodecamp-logo.7c2c796aade84f2f474c8e4e099d9152.svg";
export { ForwardRef as ReactComponent };